import $ from 'jquery';
import './form-dependent';
import 'parsleyjs';
import { format, add } from 'date-fns';

if ($('.custom-form').length) {
    // Parsley Validation Config
    const parsleyConfig = {
        errorsContainer(field) {
            return field.$element.closest('.sq-form-question');
        },
        errorsWrapper: "<p class='sq-form-error'></p>",
        errorTemplate: '<span></span>',
    };

    // Parsley Custom Validation Rules
    window.Parsley.addValidator('select', {
        requirementType: 'string',
        validateString(value) {
            return /\b/.test(value);
        },
        messages: {
            en: 'Please select an option.',
        },
    });

    window.Parsley.addValidator('checkChildren', {
        requirementType: 'string',
        validateString(value, requirement) {
            let filled = false;
            $(`[data-parsley-group="${requirement}"]`).each(function () {
                if (this.value.length) {
                    filled = true;
                }
            });
            if (filled) {
                return true;
            }
            return false;
        },
        messages: {
            en: 'You must correctly fill at least one of the %s',
        },
    });
    window.Parsley.addValidator('exactLength', {
        requirementType: 'integer',
        validateString(value, requirement) {
            const exactLength = parseInt(requirement, 10);
            if (value.length === exactLength || value.length === 0) {
                return true;
            }
            return false;
        },
        messages: {
            en: 'You must enter %s digit number with no spaces',
        },
    });

    // Apply Parsley Validation to custom forms
    $('.custom-form')
        .parsley(parsleyConfig)
        .on('field:validated', function () {
            const question = this.$element.closest('.sq-form-question');
            const form = this.parent.$element;
            if (this.validationResult === true) {
                question.removeClass('sq-form-question-error');
                if (question.find('[data-parsley-check-children]').length) {
                    const group = question
                        .find('[data-parsley-check-children]')
                        .data('parsley-check-children');
                    $(`[data-parsley-group="${group}"]`)
                        .parents('.sq-form-question')
                        .removeClass('sq-form-question-error');
                }

                if (question.find('[data-parsley-file-group]').length) {
                    const group = form.find('[data-parsley-file-group]');
                    let flag = false;
                    for (let i = 0; i < group.length; i++) {
                        const input = group[i];
                        if (input.files.length > 0) {
                            flag = true;
                        }
                    }

                    if (flag === false) {
                        question.addClass('sq-form-question-error');
                        let msg = question
                            .find('[data-parsley-file-group]')
                            .data('parsley-file-group-message');

                        if (typeof msg === 'undefined') {
                            msg = 'Please add at least one document.';
                        }
                        question.append(
                            `<p class="sq-form-error" aria-hidden="false"><span class="parsley-required">${msg}</span></p>`
                        );
                    } else {
                        question.removeClass('sq-form-question-error');
                        question.find('.sq-form-error').remove();
                    }
                }
            } else if (this.$element.is(':hidden')) {
                question.removeClass('sq-form-question-error');
                this.validationResult = true;
            } else {
                question.addClass('sq-form-question-error');
                if (question.find('[data-parsley-check-children]').length) {
                    const group = question
                        .find('[data-parsley-check-children]')
                        .data('parsley-check-children');
                    $(`[data-parsley-group="${group}"]`)
                        .parents('.sq-form-question')
                        .addClass('sq-form-question-error');
                }
            }
            if (form.find('.sq-form-question-error').length) {
                let num = form.find('.sq-form-question-error').length;
                if (num === 1) {
                    num += ' error';
                } else {
                    num += ' errors';
                }
                form.find('.in-page-alert--palette-red').removeClass('hidden');
                form.find('.in-page-alert__contents-text').html(
                    `Your form contains ${num} that must be corrected before continuing.`
                );
            } else {
                form.find('.in-page-alert--palette-red').addClass('hidden');
            }
        });

    // Hide legend
    $('.custom-form [data-hide-legend]').each(function () {
        $(this).closest('.sq-form-question').find('legend').addClass('sr-only');
    });

    // Update min/max based on dependency
    $('.custom-form [data-date-dependency]').each(function () {
        const id = $(this).attr('data-date-dependency');
        let length = null;
        if ($(this).attr('data-date-dependency-length')) {
            length = JSON.parse($(this).attr('data-date-dependency-length'));
        }
        $(this).change(function () {
            const date = format(new Date(this.value), 'yyyy-MM-dd');
            $(id).attr('min', date);
            if (length) {
                let newDate = add(new Date(this.value), length);
                newDate = format(newDate, 'yyyy-MM-dd');
                $(id).attr('max', newDate);
            }
        });
    });
}
